module.exports = "<router-outlet>\r\n</router-outlet>\r\n<spinner [backgroundColor]=\"'#951623'\" [spinner]=\"spinkit.skDoubleBounce\" [debounceDelay]=\"200\"></spinner>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main